import { Box, Flex, HStack } from '@chakra-ui/react';
import Body1 from '@components/typography/Body1';
import Body2 from '@components/typography/Body2';
import AddLink from '../../AddLink';
import EditLink from '../../EditLink';

const Pharmacy = ({ pharmacy }) => {
  const slug = 'pharmacies';

  return (
    <Flex mb={5} direction="column" minWidth={{ lg: '240px' }} flexBasis={{ lg: '250px' }} flexGrow={1} gap={1}>
      <HStack>
        <Body1 bold>Pharmacy</Body1>
        {pharmacy && <EditLink slug={slug} />}
      </HStack>
      {pharmacy ? (
        <Box>
          <Body2 bold>{pharmacy.name}</Body2>
          <Body2>{pharmacy.address_line_one}</Body2>
          <Body2>{`${pharmacy.city}, ${pharmacy.state}`}</Body2>
        </Box>
      ) : (
        <Flex w="100%">
          <AddLink slug="pharmacies" />
        </Flex>
      )}
    </Flex>
  );
};

export default Pharmacy;
